import { OktaAuth} from '@okta/okta-auth-js'

export const TOKEN_RENEWED = 'renewed'

const config = {
	pkce: true,
	tokenManager: {
		autoRenew: true,
		expireEarlySeconds: 30
	}
}

let authClient: any

export const setupOkta = (client_id: string, redirect_uri: string, issuer: string) => {
	authClient = new OktaAuth(
		{
			...config,
			clientId: client_id,
			redirectUri: redirect_uri,
			issuer: issuer,
			scopes: ['openid', 'email', 'profile', 'offline_access']
		}
	)
}

export const getAuthClient = () => {
	return authClient
}
